import { render } from "./Anesthesiology.vue?vue&type=template&id=1677f3a1"
import script from "./Anesthesiology.vue?vue&type=script&lang=ts"
export * from "./Anesthesiology.vue?vue&type=script&lang=ts"
script.render = render

export default script